export const WHATS_NEW_CONTENT = '/info/users'
export const WHATS_NEW_DATA = '/info-data'
